module.exports = __webpack_public_path__ + "static/media/small_loader.592671d8.gif";